import React, {Component} from 'react'
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import AuthService from './services/auth.service'
import {UserAction} from "./actions/UserAction"
import GuardedRoute from './components/GuardedRoute'
import Login from './components/Login'
import Error from './components/Error'
import {message} from "antd"
import Header from "./components/Header";
import Footer from "./components/Footer";
import {mainPage} from "./constants";
import i18n from "i18next";
import {CommonAction} from "./actions/CommonAction";
import MetaTags from 'react-meta-tags'
import BlogEditor from "./components/BlogEditor";
import Dashboard from "./components/DashboardComponents/DashboardContainer";
import ParserControllerContainer from './components/ParserControllerComponents/ParserControllerContainer'
import ParserConfigListComponent from './components/ParserControllerComponents/ParserConfigListComponent'
import UsersListComponent from './components/UserControllerComponents/UsersListComponent'
import AddOrUpdateUserComponent from './components/UserControllerComponents/AddOrUpdateUserComponent'
import AddOrUpdateCompanyComponent from './components/CompanyControllerComponents/AddOrUpdateCompanyComponent'
import CompaniesListComponent from './components/CompanyControllerComponents/CompaniesListComponent'
import AddOrUpdateConfigComponent from './components/ConfigControllerComponents/AddOrUpdateConfigComponent'
import ConfigsListComponent from './components/ConfigControllerComponents/ConfigsListComponent'
import AddOrUpdateSanctionListComponent from './components/SanctionListControllerComponents/AddOrUpdateSanctionListComponent'
import SanctionListsListComponent from './components/SanctionListControllerComponents/SanctionListsListComponent'
import TestsListComponent from './components/TestControllerComponents/TestsListComponent'
import AddOrUpdateTestComponent from './components/TestControllerComponents/AddOrUpdateTestComponent'


export class App extends Component {

    render() {

        const currentUser = AuthService.getCurrentUser()
        const isAuthenticated = currentUser && currentUser.accessToken && currentUser.accessToken !== "";
        const nextPage = isAuthenticated ? "dashboard" : "login";
        const showHeader = !mainPage.includes(nextPage);

        message.config({top: showHeader ? (window.innerWidth < 767 ? 66 : (window.innerWidth < 991 ? 149 : 99)) : 13})

        return (
            <>
                <MetaTags>
                    <meta content={i18n.t('meta_desc')} name="description"/>
                    <meta content={i18n.t('meta_keys')} name="keywords"/>
                </MetaTags>

                <BrowserRouter>
                    {showHeader && <Header/>}

                    <Switch>
                        <Route path="/login" render={props => {
                            if (nextPage === "dashboard") {
                                return <Redirect to={'/dashboard'}/>
                            }

                            return <Login {...props} collapseSwitch={nextPage}/>
                        }}/>

                        <GuardedRoute path='/blog-editor' component={BlogEditor} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/dashboard' component={Dashboard} auth={isAuthenticated} hasRole={true}/>

                        <GuardedRoute path='/parser-controller' component={ParserConfigListComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/add-parser' component={ParserControllerContainer} auth={isAuthenticated} hasRole={true}/>

                        <GuardedRoute path='/user-controller' component={UsersListComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/add-user' component={AddOrUpdateUserComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/update-user/:userID' component={AddOrUpdateUserComponent} auth={isAuthenticated} hasRole={true}/>

                        <GuardedRoute path='/company-controller' component={CompaniesListComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/add-company' component={AddOrUpdateCompanyComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/update-company/:companyID' component={AddOrUpdateCompanyComponent} auth={isAuthenticated} hasRole={true}/>

                        <GuardedRoute path='/config-controller' component={ConfigsListComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/add-config' component={AddOrUpdateConfigComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/update-config/:configID' component={AddOrUpdateConfigComponent} auth={isAuthenticated} hasRole={true}/>

                        <GuardedRoute path='/sanction-list-controller' component={SanctionListsListComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/add-sanction-list' component={AddOrUpdateSanctionListComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/update-sanction-list/:sanctionListID' component={AddOrUpdateSanctionListComponent} auth={isAuthenticated} hasRole={true}/>

                        <GuardedRoute path='/test-controller' component={TestsListComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/add-test' component={AddOrUpdateTestComponent} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/update-test/:testID' component={AddOrUpdateTestComponent} auth={isAuthenticated} hasRole={true}/>

                        <GuardedRoute path='/not-found' component={Error} auth={isAuthenticated} hasRole={true}/>
                        <Redirect to={'/dashboard'}/>
                    </Switch>

                    {showHeader && <Footer/>}
                </BrowserRouter>
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common,
        menu: state.menu
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(App);

